import React, { useState, useEffect } from "react";
import CategoryTable from "./CategoryTable";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";

import useSearch from "../../hooks/useSearch";
import { categoryGroups, categoryGroupItems } from "../../constants";
import { CategoriesService } from "../../utils/api";
import { useCategoriesContext } from "./CategoriesContext";

const Category = ({ location, history }) => {
  const { search, setSearch, loading, data } = useCategoriesContext();

  return (
    <div className="common-category">
      <div className="common-category__controls">
        <ButtonGroup
          items={categoryGroupItems}
          selected={search.group}
          onClick={value => {
            setSearch({ group: value });
          }}
        />
      </div>
      <CategoryTable loading={loading} categories={data?.categories ?? []} />
    </div>
  );
};

export default Category;
